module.exports = __webpack_public_path__ + "img/Small-Semi-Elliptical-Attachment-L-47.b6ee1f88.png";